import { idtype } from "querypieces";

export const impactItems = `impactItems {
  ...on impactItemsItem_Entry {
    ${idtype}
    number
    label
    explainer
  }
}`;

export default `
  ...on pageBuilder_impactItems_BlockType {
    ${idtype}
    ${impactItems}
  }
`;
